import { useEffect, useRef, useState } from 'react'

/**
 * @param ref reference to component
 * @param threshold how much of the component needs to be visible for visibility state to change
 * @returns
 * @author https://stackoverflow.com/a/67826055/19258694
 * @deprecated ⚠️⚠️ Please use useIntersectionObserver from '@ecomm/web-apis/useIntersectionObserver' instead. ⚠️⚠️
 */
export function useIsOnScreen(
  ref: React.MutableRefObject<HTMLElement | null>,
  threshold = 0.5
) {
  const [isOnScreen, setIsOnScreen] = useState(false)
  const observerRef = useRef<IntersectionObserver>()

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]) => setIsOnScreen(entry?.isIntersecting ?? false),
      { threshold: threshold }
    )
  }, [threshold])

  useEffect(() => {
    ref.current && observerRef.current?.observe(ref.current)

    return () => {
      observerRef.current?.disconnect()
    }
  }, [ref])

  return isOnScreen
}
